import VerifyDocumentCloseProjectREC1 from '../../../page/verifyDocumentCloseProject/verifyDocumentCloseProjectREC1'
import VerifyDocumentCloseProjectREC2 from '../../../page/verifyDocumentCloseProject/verifyDocumentCloseProjectREC2'
import { OfficerType } from './officerType'
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import * as Constants from '../../../../../../constants/constants'
import Synthesis from '../../../page/synthesis/closeProject/synthesis'
import ReportedCloseProject from '../../../page/memoMessage/reportedCloseProject/reportedCloseProject'
import SignREC1 from '../../../page/sign/signMemoMessage/signREC1'
import SignREC2 from '../../../page/sign/signMemoMessage/signREC2'
import SignRepresentREC1 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC1'
import SignRepresentREC2 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC2'
import ResultOfConsiderPrevious from '../../../page/resultOfConsiderPrevious/closeProject/resultOfConsiderPrevious'
import constSubmittedStep from '../../../../../../constants/submittedStep'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import submittedStatus from '../../../../../../constants/submittedStatus'

const OfficerView: React.FC<OfficerType> = (props) => {
    const { callbackSaveComplete } = props
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const checkPermission = useCheckPermission()

    const renderPage = () => {
        const tabID = appFolderAndTabStore?.tabSelected?.id
        const REC = manageProjectStore?.projectData?.irbType
        let isNotDisableTestResult = false
        switch (REC) {
            case 1:
                switch (tabID) {
                    case Constants.menuTab.tab1.id:
                        // tab1 <div> ตรวจสอบเอกสาร REC1</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.sign &&
                                manageProjectStore?.projectData?.submittedStatusInfo?.value !== submittedStatus.complete
                        }
                        return (
                            <VerifyDocumentCloseProjectREC1
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                                isNotDisableTestResult={isNotDisableTestResult}
                            />
                        )
                    case Constants.menuTab.tab11.id:
                        return (
                            <ReportedCloseProject
                                projectModeEdit
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab9.id:
                        return <SignREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        return <SignRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab26.id:
                        return (
                            <>
                                <ResultOfConsiderPrevious
                                    projectID={manageProjectStore?.projectData?.projectID ?? 0}
                                    submittedID={
                                        manageProjectStore?.projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0
                                    }
                                />
                            </>
                        )
                    default:
                        return <div></div>
                }

            case 2:
                switch (tabID) {
                    case Constants.menuTab.tab1.id:
                        // tab1
                        // return <div> ตรวจสอบเอกสาร REC2</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.sign &&
                                manageProjectStore?.projectData?.submittedStatusInfo?.value !== submittedStatus.complete
                        }
                        return (
                            <VerifyDocumentCloseProjectREC2
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                                isNotDisableTestResult={isNotDisableTestResult}
                            />
                        )
                    case Constants.menuTab.tab6.id:
                        return (
                            <Synthesis
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )
                    case Constants.menuTab.tab11.id:
                        return (
                            <ReportedCloseProject
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                                projectModeEdit
                            />
                        )
                    case Constants.menuTab.tab9.id:
                        return <SignREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        return <SignRepresentREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab26.id:
                        return (
                            <>
                                <ResultOfConsiderPrevious
                                    // projectData2={projectData}
                                    projectID={manageProjectStore?.projectData?.projectID ?? 0}
                                    submittedID={
                                        manageProjectStore?.projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0
                                    }
                                />
                            </>
                        )
                    default:
                        return <div></div>
                }

            default:
                return <div></div>
        }
    }

    return <> {renderPage()} </>
}

const Officer: React.FC<OfficerType> = (props) => {
    return <OfficerView {...props} />
}
export default Officer
